import { DestroyRef, Directive, effect, inject, input, signal } from '@angular/core';

@Directive({
  selector: '[appOddsValueFlash]',
  standalone: true,
  host: {
    '[class.sb-odds-value-flash]': 'isFlashing()'
  }
})
export class OddsValueFlashDirective {
  readonly appOddsValueFlash = input<number | null>(null);

  protected readonly isFlashing = signal(false);

  private readonly destroyRef = inject(DestroyRef);
  private previousValue: number | null | undefined = undefined;
  private timeoutId: ReturnType<typeof setTimeout> | undefined;

  constructor() {
    effect(() => {
      const currentValue = this.appOddsValueFlash();

      if (this.previousValue === undefined) {
        this.previousValue = currentValue;
        return;
      }

      const shouldFlash = this.previousValue !== null && currentValue !== null && this.previousValue !== currentValue;
      this.previousValue = currentValue;

      if (!shouldFlash) {
        return;
      }

      this.isFlashing.set(false);
      queueMicrotask(() => this.isFlashing.set(true));

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      this.timeoutId = setTimeout(() => this.isFlashing.set(false), 820);
    });

    this.destroyRef.onDestroy(() => {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
    });
  }
}
